import {
  SET_FILTER_LOCATION,
  SET_HAZARD,
  SET_ANALYSISTYPE,
  SET_STARTYEAR,
  SET_ENDYEAR,
  SET_STATES,
  SET_COUNTIES,
  SET_CITIES,
  SET_STATE_SELECTED,
  SET_COUNTY_SELECTED,
  SET_CITY_SELECTED,
  CLEAR_FILTERS,
  SET_FILTER_ECONOMIC_LOSS_MAX,
  SET_FILTER_ECONOMIC_LOSS_MIN,
} from "../actions/types";

const initialState = {
  resultType: {
    event: false,
    location: false,
  },
  stateSelected: { id: null, name: null, geom_id: null },
  countySelected: { id: null, name: null, geom_id: null },
  citySelected: { id: null, name: null, geom_id: null },
  locations: {
    states: [],
    counties: [],
    cities: [],
  },
  hazard: {
    earthquake: false,
    flood: false,
    hurricane: false,
    tsunami: false,
  },
  analysisType: {
    historic: false,
    probabilistic: false,
    deterministic: false,
  },
  startYear: null,
  endYear: null,
  scale: "",
  economicLossMin: null,
  economicLossMax: null,
};

const filterReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_FILTER_LOCATION:
      return { ...state, location: payload };
    case SET_HAZARD:
      return { ...state, hazard: payload };
    case SET_ANALYSISTYPE:
      return { ...state, analysisType: payload };
    case SET_STARTYEAR:
      return { ...state, startYear: payload };
    case SET_ENDYEAR:
      return { ...state, endYear: payload };
    case SET_STATES:
      return { ...state, locations: { ...state.locations, states: payload } };
    case SET_COUNTIES:
      return { ...state, locations: { ...state.locations, counties: payload } };
    case SET_CITIES:
      return { ...state, locations: { ...state.locations, cities: payload } };
    case SET_STATE_SELECTED:
      return payload
        ? { ...state, stateSelected: payload }
        : { ...state, stateSelected: initialState.stateSelected };
    case SET_COUNTY_SELECTED:
      return payload
        ? { ...state, countySelected: payload }
        : { ...state, countySelected: initialState.countySelected };
    case SET_CITY_SELECTED:
      return payload
        ? { ...state, citySelected: payload }
        : { ...state, citySelected: initialState.citySelected };
    case SET_FILTER_ECONOMIC_LOSS_MAX:
      return { ...state, economicLossMax: payload };
    case SET_FILTER_ECONOMIC_LOSS_MIN:
      return { ...state, economicLossMin: payload };
    case CLEAR_FILTERS:
      return { ...state, ...JSON.parse(JSON.stringify(initialState)) };
    default:
      return state;
  }
};

export default filterReducer;
